export const scrollIntoView = (
  element: HTMLElement,
  offsetVal = 0,
  scrollBehavior = 'smooth'
): void => {
  if (!element) return;
  const offset = offsetVal;
  const bodyRect = document.body.getBoundingClientRect().top;
  const elementRect = element.getBoundingClientRect().top;
  const elementPosition = elementRect - bodyRect;
  const offsetPosition = elementPosition - offset;

  window.scrollTo({
    top: offsetPosition,
    behavior: scrollBehavior as ScrollBehavior,
  });
};
